module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/300-6c1dcc5693723b96fe52b2656f087efb.jpg";